import axios from 'axios'
import _get from 'lodash/get'

import { ERROR_MESSAGE_DELETING, ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const CREATE_SELF_EMPLOYMENT_EXPENSE = 'CREATE_SELF_EMPLOYMENT_EXPENSE'
export const DELETE_SELF_EMPLOYMENT_EXPENSE = 'DELETE_SELF_EMPLOYMENT_EXPENSE'
export const RECEIVE_SELF_EMPLOYMENT_EXPENSES = 'RECEIVE_SELF_EMPLOYMENT_EXPENSES'
export const REMOVE_SELF_EMPLOYMENT_EXPENSE = 'REMOVE_SELF_EMPLOYMENT_EXPENSE'
export const REQUEST_SELF_EMPLOYMENT_EXPENSE = 'REQUEST_SELF_EMPLOYMENT_EXPENSE'
export const REQUEST_SELF_EMPLOYMENT_EXPENSES = 'REQUEST_SELF_EMPLOYMENT_EXPENSES'
export const SAVE_SELF_EMPLOYMENT_EXPENSE = 'SAVE_SELF_EMPLOYMENT_EXPENSE'

export const requestSelfEmploymentExpenses = (data) => (dispatch) => {
    dispatch({ type: REQUEST_SELF_EMPLOYMENT_EXPENSES, data })

    const { selfEmploymentId } = data

    axios
        .get(`/selfemployment/${selfEmploymentId}/selfemploymentexpenses`)
        .then((response) => {
            const items = _get(response, ['data'], [])
            dispatch(receiveSelfEmploymentExpenses({ items }, { fetchSuccessful: true }))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(receiveSelfEmploymentExpenses({}, { fetchSuccessful: true }))
                return
            }

            dispatch(receiveSelfEmploymentExpenses({}, { fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

// export const requestSelfEmploymentExpense = (data) => {
//     return (dispatch) => {
//         dispatch({ type: REQUEST_SELF_EMPLOYMENT_EXPENSE })
//
//         const { id } = data
//
//         axios
//             .get(`/selfemploymentexpense/${id}`)
//             .then((response) => {
//                 const item = _get(response, ['data'], {})
//                 dispatch(receiveSelfEmploymentExpenses({ items: [item] }))
//             })
//             .catch((error) => {
//                 if (_get(error, ['response', 'status']) === 404) {
//                     return
//                 }
//
//                 dispatch(handleRequestError(error))
//             })
//     }
// }

export const receiveSelfEmploymentExpenses =
    (data, meta = {}) =>
    (dispatch) => {
        dispatch({ type: RECEIVE_SELF_EMPLOYMENT_EXPENSES, data, meta })
    }

export const saveSelfEmploymentExpense = (data) => (dispatch) => {
    dispatch({ type: SAVE_SELF_EMPLOYMENT_EXPENSE })

    const { id } = data

    return axios
        .put(`/selfemploymentexpense?id=${id}`, data)
        .then((response) => {
            const item = _get(response, ['data'], {})
            dispatch(receiveSelfEmploymentExpenses({ items: [item] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const createSelfEmploymentExpense = (data) => (dispatch) => {
    dispatch({ type: CREATE_SELF_EMPLOYMENT_EXPENSE })

    return axios
        .post(`/selfemploymentexpense`, data)
        .then((response) => {
            const item = _get(response, ['data'], {})
            dispatch(receiveSelfEmploymentExpenses({ items: [item] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const deleteSelfEmploymentExpense = (data) => (dispatch) => {
    dispatch({ type: DELETE_SELF_EMPLOYMENT_EXPENSE, data })

    const { id } = data

    return axios
        .delete(`/selfemploymentexpense/${id}`)
        .then(() => {
            dispatch(removeSelfEmploymentExpense({ id }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING }))
            return Promise.reject(error)
        })
}

export const removeSelfEmploymentExpense = (data) => (dispatch) => {
    dispatch({ type: REMOVE_SELF_EMPLOYMENT_EXPENSE, data })
}
